import { render, staticRenderFns } from "./location-company-modal.vue?vue&type=template&id=764c8792&"
import script from "./location-company-modal.vue?vue&type=script&lang=js&"
export * from "./location-company-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports